import { notification } from '@surecompanies/core_components'
import { useMutation } from '@tanstack/react-query'

import type { CreateRecruitingRequest } from '../schema'
import { CreateRecruitingResponse, postRecruiting } from '../api'
import { getErrorMessage } from '../helpers/getErrorMessage'

export function useGenerateRecruitingInvitation(
  _clientPublicKey?: string | null
) {
  return useMutation<CreateRecruitingResponse, Error, CreateRecruitingRequest>({
    mutationFn: postRecruiting,
    onError: (error) => {
      notification.error({
        message: getErrorMessage(
          error,
          'Could not generate recruiting invitation. Please try again.'
        ),
        duration: 60,
      })
    },
  })
}
